import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';
import i18next from 'i18next';
import { IUserMenuLink } from '../interface/user-menu-link.interface';
import { useUserPermissions } from '@vivli/features/users/infrastructure/hook';
import { AssetsConstant } from '@vivli/shared/infrastructure/constants';
import { useActiveUserContext, useAssignedAppTypeContext } from '@vivli/core/infrastructure/context';

const order = [
    'Dashboard',
    'Data Requests',
    'Enquiries',
    'Studies',
    'Reports',
    'Research Environments',
    'My Organization',
    'My Organizations',
    'Users',
    'Submissions',
    'Admin Console'
];

export function useUserMenuRoutes() {
    //used only for AMR now
    const { user, hasPermission } = useActiveUserContext();
    const { isOrgOrVivliAdmin, isDataProvider, isAnnotator, isQaReviewer, isIRPApprover } = useUserPermissions();

    if (!user) {
        return [];
    }

    //TODO PERMFE -replace to permissions+
    const isVivliAdmin = hasPermission(PermissionsEnum.DrActAdv);
    const isOpsAdmin = hasPermission(PermissionsEnum.UseAdmConsoleAdv);

    //TODO PERMFE - redo with permissions+
    const orgs = user.orgMemberships?.filter((om) => om.vivliPermissions?.some((p) => p === PermissionsEnum.ProviderActAdv));
    let orgId = null;
    if (orgs && orgs.length !== 0) {
        [{ orgId }] = orgs;
    }

    let links: Array<IUserMenuLink> = [
        {
            title: 'Dashboard',
            icon: {
                active: AssetsConstant.DASHBOARD_ICON_ACTIVE,
                inactive: AssetsConstant.DASHBOARD_ICON_INACTIVE
            },
            url: 'dashboard',
            defaultTab: '',
            dataId: 'menuitem_dashboard'
        },
        {} // empty placeholder key for admin portal side nav panels
    ];

    if (user?.orgMemberships) {
        if (isVivliAdmin) {
            links = [
                ...links,
                {
                    title: 'Users',
                    icon: {
                        active: AssetsConstant.ORGANIZATIONS_ICON_ACTIVE,
                        inactive: AssetsConstant.ORGANIZATIONS_ICON_INACTIVE
                    },
                    url: `users`,
                    defaultTab: '',
                    dataId: 'menuitem_users'
                }
            ];
        }
        if (isOrgOrVivliAdmin || isVivliAdmin) {
            links = [
                ...links,
                {
                    title: 'Reports',
                    icon: {
                        active: AssetsConstant.TRIALS_ICON_ACTIVE,
                        inactive: AssetsConstant.TRIALS_ICON_INACTIVE
                    },
                    url: `report`,
                    defaultTab: '',
                    dataId: 'menuitem_report'
                }
            ];
            links = [
                ...links,
                {
                    //TODO PERMFE - redo with permissions+
                    title: 'My Organizations',
                    icon: {
                        active: AssetsConstant.OFFICEBUILDING_ICON_ACTIVE,
                        inactive: AssetsConstant.OFFICEBUILDING_ICON_INACTIVE
                    },
                    url: 'orgs',
                    defaultTab: '',
                    dataId: 'menuitem_my_organizations'
                }
            ];
        }
        if (isAnnotator || isQaReviewer || isDataProvider) {
            links = [
                ...links,
                {
                    title: i18next.t('studies'),
                    icon: {
                        active: AssetsConstant.TRIALS_ICON_ACTIVE,
                        inactive: AssetsConstant.TRIALS_ICON_INACTIVE
                    },
                    url: 'studies',
                    defaultTab: 'posted',
                    dataId: 'menuitem_studies'
                }
            ];
        }
        if (isDataProvider || isIRPApprover) {
            links = [
                ...links,
                {
                    title: 'Data Requests',
                    icon: {
                        active: AssetsConstant.REQUESTS_ICON_ACTIVE,
                        inactive: AssetsConstant.REQUESTS_ICON_INACTIVE
                    },
                    url: 'requests',
                    defaultTab: 'AwaitingMyAction',
                    dataId: 'menuitem_data_requests'
                }
            ];
        }

        if (isOpsAdmin) {
            links = [
                ...links,
                {
                    title: 'Admin Console',
                    icon: {
                        active: AssetsConstant.ORGANIZATIONS_ICON_ACTIVE,
                        inactive: AssetsConstant.ORGANIZATIONS_ICON_INACTIVE
                    },
                    url: `adminConsole`,
                    defaultTab: 'templateStudy',
                    dataId: 'menuitem_admin_console'
                }
            ];
        }
    } else {
        if (isVivliAdmin || isOpsAdmin) {
            links = [
                ...links,
                {
                    //TODO PERMFE - redo with permissions+
                    title: 'Organizations',
                    icon: {
                        active: AssetsConstant.OFFICEBUILDING_ICON_ACTIVE,
                        inactive: AssetsConstant.OFFICEBUILDING_ICON_INACTIVE
                    },
                    url: 'orgs',
                    defaultTab: '',
                    dataId: 'menuitem_my_organizations'
                }
            ];
            links = [
                ...links,
                {
                    title: 'Users',
                    icon: {
                        active: AssetsConstant.ORGANIZATIONS_ICON_ACTIVE,
                        inactive: AssetsConstant.ORGANIZATIONS_ICON_INACTIVE
                    },
                    url: `users`,
                    defaultTab: '',
                    dataId: 'menuitem_users'
                }
            ];
        }
    }

    links.sort((a, b) => {
        if (!a.title) return 1;
        if (!b.title) return -1;

        const indexA = order.indexOf(a.title);
        const indexB = order.indexOf(b.title);
        return indexA - indexB;
    });

    return links;
}
